import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Style/Tutorial.css';
import Questions from './Image/questions.png';
import back_n from "../Tutorials/Image/back_n.gif";
import back_o from "../Tutorials/Image/back_o.gif";
import back_d from "../Tutorials/Image/back_d.gif";
import previous_n from "../Tutorials/Image/previous_n.gif";
import previous_o from "../Tutorials/Image/previous_o.gif";
import previous_d from "../Tutorials/Image/previous_d.gif";
import nextstep_n from "../Tutorials/Image/nextstep_n.gif";
import nextstep_o from "../Tutorials/Image/nextstep_o.gif";
import nextstep_d from "../Tutorials/Image/nextstep_d.gif";
import nextpage_n from "../Tutorials/Image/nextpage_n.gif";
import nextpage_o from "../Tutorials/Image/nextpage_o.gif";
import nextpage_d from "../Tutorials/Image/nextpage_d.gif";
import questions_n from "../Tutorials/Image/questions_n.gif";
import questions_o from "../Tutorials/Image/questions_o.gif";
import questions_d from "../Tutorials/Image/questions_d.gif";
import Loading from '../../Common/Loading';
import WhiteboardLink from '../../Common/WhiteboardLink';

const TutorialCopy: React.FC = () => {
  const navigate = useNavigate();
  const [backSrc, setBackSrc] = useState(`${back_n}`);
  const [previousSrc, setPreviousSrc] = useState(`${previous_n}`);
  const [nextStepSrc, setNextStepSrc] = useState(`${nextstep_n}`);
  const [nextpageSrc, setNextpageSrc] = useState(`${nextpage_n}`);
  const [questionsSrc, setQuestionsSrc] = useState(`${questions_n}`);
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [hasMoreSteps, setHasMoreSteps] = useState(false);
  const [iframeSrc, setIframeSrc] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const apiUrl = process.env.REACT_APP_DOCUMENT_LINK;

  const addNavigationScript = (htmlContent: string) => {
    const legacyStyles = `
      <style>
        html, body {
          height: 100%;
          margin: 0px !important;
          padding: 0px !important;
          border: 0px !important;
          width: 100%;
          min-height: 100vh !important; 
        }
        
        img {
            border: 0;
            display: inline-block;
        }

        .QnPanel { filter: progid:dximagetransform.microsoft.gradient(gradienttype=0, startcolorstr='#d8e4f8', endcolorstr='#7a96df'); background-color: #7a96df; }
        .AnsOK { background-color: green; width: 100%; }
        .AnsWrong1 { background-color: Red; width: 100%; }
        .AnsWrong2 { background-color: Blue; width: 100%; }
        .QnPanelTitle { font-family: Arial; font-size: medium; font-weight: bold; color: white; height: 25px; }
        .tdQnMid { width: 100%; height: 585px; }
        .tdTutMid { width: 100%; height: 610px; }
        .TutNav { width: 100%; height: 55px; }
        .HeadMsg { background-color: #E4E4E4; font-size: small; font-weight: bold; font-family: Arial; color: cornflowerblue; height: 20px; width: 100%; padding-left: 10px; text-align: left; vertical-align: middle; }
        .tdLsnHead { font-family: Trebuchet MS; font-size: 10pt; }
        .tdLsnName { font-family: Trebuchet MS; font-size: 10pt; color: Blue; }
        .tdLbl { font-family: Arial; font-size: 16pt; color: Blue; }
        .trDet { font-family: Arial; font-size: 10pt; height: 20px; }
        .tdDet1 { border-color: Black; border-style: solid; border-bottom-style: none; border-width: 1px; padding-left: 5px; }
        .tdDet2 { border-color: Black; border-style: solid; border-bottom-style: none; border-width: 1px; border-left-style: none; padding-left: 5px; }
        .tdRepDesc { font-family: Arial; font-size: 12pt; font-weight: bold; color: #cc3366; }
        .tdHead { font-family: Trebuchet MS; font-size: 10pt; height: 20px; color: White; font-weight: bold; padding-left: 5px; }
        
        #imgNextStep, #imgBtnQuestions {
          display: none !important;
        }
      </style>
    `;

    const scriptToAdd = `
    <script>
      var currentPage = 1;
      var currentStep = 0;
      var totalStepsInPage = 0;
      var stepElements = [];

      function initPage(pageNumber) {
        currentPage = pageNumber;
        currentStep = 0;

        var bodyBg = document.body.style.backgroundColor;
        if (!bodyBg || bodyBg === 'rgba(0, 0, 0, 0)' || bodyBg === 'transparent') {
            var computed = window.getComputedStyle(document.body);
            bodyBg = computed.backgroundColor;
        }
        if (bodyBg && bodyBg !== 'rgba(0, 0, 0, 0)' && bodyBg !== 'transparent') {
            document.documentElement.style.backgroundColor = bodyBg;
        } else {
            document.documentElement.style.backgroundColor = "white";
            document.body.style.backgroundColor = "white";
        }

        const allDivShows = document.querySelectorAll('div[id^="divShow"]');
        allDivShows.forEach(div => {
            div.style.display = 'none';
            
            const iframes = div.getElementsByTagName('iframe');
            for (let frame of iframes) {
                if (frame.getAttribute('src')) {
                    if (!frame.dataset.src) {
                        frame.dataset.src = frame.getAttribute('src');
                    }
                    frame.removeAttribute('src'); 
                }
            }
        });

        const targetDiv = document.getElementById('divShow' + pageNumber);
        if (targetDiv) {
          targetDiv.style.display = 'block'; 
          
          const prefix = 'TABLE_P' + pageNumber + '_';
          const stepTables = targetDiv.querySelectorAll('table');
          stepElements = Array.from(stepTables).filter(tbl => tbl.id && tbl.id.startsWith(prefix));
          totalStepsInPage = stepElements.length;

          stepElements.forEach((el, index) => {
            el.style.display = index === 0 ? '' : 'none';
          });

          const iframes = targetDiv.getElementsByTagName('iframe');
          for (let frame of iframes) { 
            frame.style.display = 'block';
            if (frame.dataset.src && !frame.getAttribute('src')) {
                frame.src = frame.dataset.src;
            }
          }

        } else {
          totalStepsInPage = 0;
          stepElements = [];
        }

        notifyParent();
      }

      function nextStep() {
        if (currentStep + 1 < totalStepsInPage) {
          currentStep++;
          if(stepElements[currentStep]) {
            stepElements[currentStep].style.display = '';
          }
          notifyParent();
        }
      }

      function notifyParent() {
        if (window.parent && window.parent.postMessage) {
          window.parent.postMessage({
            type: 'STATE_UPDATE',
            payload: {
              totalPages: document.querySelectorAll('div[id^="divShow"]').length,
              currentPage: currentPage,
              currentStep: currentStep,
              totalSteps: totalStepsInPage,
              hasMoreSteps: (currentStep + 1) < totalStepsInPage
            }
          }, '*');
        }
      }

      window.addEventListener('message', function(event) {
        const data = event.data;
        if (data.type === 'NAVIGATE_PAGE') initPage(data.pageNumber);
        else if (data.type === 'NEXT_STEP') nextStep();
        else if (data.type === 'STOP_AUDIO') {
          document.querySelectorAll("audio, video").forEach(media => {
            if (!media.paused) { media.pause(); media.currentTime = 0; }
          });
          
          const currentDiv = document.getElementById('divShow' + currentPage);
          if (currentDiv) {
             // For "Back/Next" buttons, NAVIGATE_PAGE is called, which handles the unloading above.
          }
        }
      });

      window.addEventListener('load', function() {
        initPage(1);
        document.oncontextmenu = function() { return false; };
        
        const allAudios = document.querySelectorAll("audio");
        allAudios.forEach(audio => {
          audio.addEventListener("play", function () {
            allAudios.forEach(a => {
              if (a !== audio) { a.pause(); a.currentTime = 0; }
            });
          });
        });
      });

    </script>
    `;

    if (/<\/head>/i.test(htmlContent)) {
      return htmlContent.replace(/<\/head>/i, legacyStyles + scriptToAdd + '</head>');
    }
    else if (/<body/i.test(htmlContent)) {
      return htmlContent.replace(/<body[^>]*>/i, (match) => match + legacyStyles + scriptToAdd);
    }
    else {
      return legacyStyles + scriptToAdd + htmlContent;
    }
  };

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const folderParam =
    params.get("id") ||
    params.get("LsnTestCode");
  const [lessonName, setLessonName] = useState(params.get('name')?.split('?')[0] || '');
  // const schoolCode = sessionStorage.getItem('SchoolCode');
  const isSSO = sessionStorage.getItem("isSSO") === "true";

  const schoolCode = isSSO
    ? new URLSearchParams(location.search).get("schoolCode")
    : sessionStorage.getItem("SchoolCode");
  const whiteboardFamilyCode = params.get("FamilyCode") || params.get("familyCode") || sessionStorage.getItem("FamilyCode");
  const whiteboardLogin = params.get("Login") || params.get("login") || sessionStorage.getItem("Login");
  const typeParam = params.get('type');
  const ylaParam = params.get('yla');
  const testLessonsParam = params.get('testLessonsBlob');

  const fetchTutorialFile = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await fetch(`${apiUrl}TutorialContent/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          folder: folderParam,
          schoolCode: schoolCode,
          type: typeParam,
          yla: ylaParam,
          testLessonsBlob: testLessonsParam
        })
      });

      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const data = await response.json();

      if (data.lessonName) {
        setLessonName(data.lessonName);
      }

      if (data.content) {
        const enhancedContent = addNavigationScript(data.content);
        const blob = new Blob([enhancedContent], { type: 'text/html' });
        const blobUrl = URL.createObjectURL(blob);
        setIframeSrc(blobUrl);
      } else {
        throw new Error('No tutorial content received');
      }
    } catch (err) {
      // console.error('Error fetching tutorial file:', err);
      setError('Failed to load tutorial content');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTutorialFile();
  }, []);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data.type === 'STATE_UPDATE') {
        const { totalPages, currentPage, hasMoreSteps } = event.data.payload;
        setTotalPages(totalPages);
        setCurrentPage(currentPage);
        setHasMoreSteps(hasMoreSteps);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    let lastX = 0;
    let lastY = 0;
    let iframeDocument: Document | null = null;
    let popup: HTMLButtonElement | null = null;
    let attachIframeEvents: () => void;
    let iframeEventHandlers: {
      document: Document;
      mouseUp: (event: MouseEvent) => void;
      touchEnd: (event: TouchEvent) => void;
      dismiss: (event: MouseEvent | TouchEvent) => void;
    } | null = null;
    const selectionTimers: number[] = [];

    const isAppleTouchDevice =
      navigator.maxTouchPoints > 1 && /Mac|iPad|iPhone/.test(navigator.platform);

    const hidePopup = () => {
      if (popup) popup.style.display = 'none';
    };

    const stopSpeech = () => {
      window.speechSynthesis?.cancel();
    };

    const createPopup = () => {
      if (popup) return;

      popup = document.createElement('button');
      popup.type = 'button';
      popup.id = 'readPopup';
      popup.setAttribute('aria-label', 'Read selected text aloud');
      popup.innerHTML = '<span aria-hidden="true">🔊</span> Read Aloud';
      Object.assign(popup.style, {
        position: 'absolute',
        display: 'none',
        zIndex: '999999',
        padding: isAppleTouchDevice ? '0 20px' : '10px 15px',
        width: isAppleTouchDevice ? '170px' : 'auto',
        height: isAppleTouchDevice ? '60px' : 'auto',
        border: '0',
        borderRadius: isAppleTouchDevice ? '30px' : '8px',
        background: '#111',
        color: '#fff',
        cursor: 'pointer',
        fontFamily: 'Arial, sans-serif',
        fontSize: isAppleTouchDevice ? '20px' : '14px',
        boxShadow: '0 6px 20px rgba(0,0,0,.25)',
        alignItems: 'center',
        justifyContent: 'center',
      });

      popup.addEventListener('click', (event) => {
        event.stopPropagation();
        const selectedText = popup?.dataset.text;
        if (!selectedText || !window.speechSynthesis) return;

        window.speechSynthesis.cancel();
        const speech = new SpeechSynthesisUtterance(selectedText);
        speech.lang = 'en-US';
        speech.rate = 1;
        speech.pitch = 1;
        window.speechSynthesis.speak(speech);
        hidePopup();
      });

      document.body.appendChild(popup);
    };

    const showPopup = (text: string, rect: DOMRect) => {
      createPopup();
      if (!popup) return;

      const iframeRect = iframe.getBoundingClientRect();
      popup.dataset.text = text;
      popup.style.left = `${iframeRect.left + window.scrollX + rect.left + rect.width / 2 - 50}px`;
      popup.style.top = `${iframeRect.top + window.scrollY + rect.bottom + 40}px`;
      popup.style.display = isAppleTouchDevice ? 'flex' : 'block';
    };

    const processSelection = () => {
      if (!iframeDocument) return;

      const activeElement = iframeDocument.activeElement;
      let text = '';
      let rect: DOMRect | null = null;

      if (activeElement?.tagName === 'INPUT' || activeElement?.tagName === 'TEXTAREA') {
        const textField = activeElement as HTMLInputElement | HTMLTextAreaElement;
        text = textField.value
          .substring(textField.selectionStart ?? 0, textField.selectionEnd ?? 0)
          .trim();
        rect = new DOMRect(lastX, lastY, 0, 0);
      } else {
        const selection = iframe.contentWindow?.getSelection();
        text = selection?.toString().trim() ?? '';
        if (selection && selection.rangeCount > 0) {
          rect = selection.getRangeAt(0).getBoundingClientRect();
        }
      }

      if (!text || !rect) {
        hidePopup();
        return;
      }

      showPopup(text, rect);
    };

    attachIframeEvents = () => {
      try {
        const nextDocument = iframe.contentDocument || iframe.contentWindow?.document;
        if (!nextDocument?.body || nextDocument === iframeDocument) return;

        if (iframeEventHandlers) {
          const { document, mouseUp, touchEnd, dismiss } = iframeEventHandlers;
          document.removeEventListener('mouseup', mouseUp);
          document.removeEventListener('touchend', touchEnd);
          document.removeEventListener('mousedown', dismiss);
          document.removeEventListener('touchstart', dismiss);
        }

        iframeDocument = nextDocument;
        const handleMouseUp = (event: MouseEvent) => {
          lastX = event.clientX;
          lastY = event.clientY;
          selectionTimers.push(window.setTimeout(processSelection, isAppleTouchDevice ? 120 : 10));
        };
        const handleTouchEnd = (event: TouchEvent) => {
          const touch = event.changedTouches[0];
          if (touch) {
            lastX = touch.clientX;
            lastY = touch.clientY;
          }
          selectionTimers.push(window.setTimeout(processSelection, 300));
        };
        const dismiss = (event: MouseEvent | TouchEvent) => {
          if ((event.target as HTMLElement)?.id !== 'readPopup') {
            hidePopup();
            stopSpeech();
          }
        };

        nextDocument.addEventListener('mouseup', handleMouseUp);
        nextDocument.addEventListener('touchend', handleTouchEnd);
        nextDocument.addEventListener('mousedown', dismiss);
        nextDocument.addEventListener('touchstart', dismiss);
        iframeEventHandlers = {
          document: nextDocument,
          mouseUp: handleMouseUp,
          touchEnd: handleTouchEnd,
          dismiss,
        };
      } catch {
        // The iframe may briefly be unavailable while the Blob document loads.
      }
    };

    const dismissParent = (event: MouseEvent | TouchEvent) => {
      if ((event.target as HTMLElement)?.id !== 'readPopup') {
        hidePopup();
        stopSpeech();
      }
    };

    createPopup();
    iframe.addEventListener('load', attachIframeEvents);
    window.setTimeout(attachIframeEvents, 1000);
    document.addEventListener('mousedown', dismissParent);
    document.addEventListener('touchstart', dismissParent);

    return () => {
      iframe.removeEventListener('load', attachIframeEvents);
      document.removeEventListener('mousedown', dismissParent);
      document.removeEventListener('touchstart', dismissParent);
      if (iframeEventHandlers) {
        const { document, mouseUp, touchEnd, dismiss } = iframeEventHandlers;
        document.removeEventListener('mouseup', mouseUp);
        document.removeEventListener('touchend', touchEnd);
        document.removeEventListener('mousedown', dismiss);
        document.removeEventListener('touchstart', dismiss);
      }
      selectionTimers.forEach(window.clearTimeout);
      popup?.remove();
      stopSpeech();
    };
  }, [iframeSrc]);

  const stopAudioInIframe = () => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: 'STOP_AUDIO' }, '*');
    }
  };

  const navigateToPage = (pageNumber: number) => {
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({
        type: 'NAVIGATE_PAGE',
        pageNumber: pageNumber
      }, '*');
    }
  };

  const handleNextStep = (e: React.MouseEvent) => {
    e.preventDefault();
    stopAudioInIframe();
    const iframe = iframeRef.current;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.postMessage({ type: 'NEXT_STEP' }, '*');
    }
  };

  const goToPreviousPage = (e: React.MouseEvent) => {
    e.preventDefault();
    stopAudioInIframe();
    const newPage = Math.max(1, currentPage - 1);
    navigateToPage(newPage);
  };

  const goToNextPage = (e: React.MouseEvent) => {
    e.preventDefault();
    stopAudioInIframe();
    const newPage = Math.min(currentPage + 1, totalPages);
    navigateToPage(newPage);
  };

  const handleBack = () => {
    stopAudioInIframe();
    if (window.confirm('Are you sure you want to quit the Lesson?')) {
      const calledFrom = params.get("calledFrom") || params.get("CalledFrom");
      if (calledFrom) {
        const redirectPath = decodeURIComponent(calledFrom);
        window.location.href = redirectPath;
      }
      else if (window.history.length > 1) {
        window.history.back();
      }
    }
  };
  const handleQuestion = () => {
    stopAudioInIframe();

    const urlParams = new URLSearchParams(window.location.search);

    const idParam =
      urlParams.get("id") ||
      urlParams.get("LsnTestCode");

    const nameParam = urlParams.get("name");

    const folderParam =
      urlParams.get("id") ||
      urlParams.get("LsnTestCode");

    const dicCodeParam = urlParams.get("diccode");

    const calledFromParam =
      urlParams.get("calledFrom") ||
      urlParams.get("CalledFrom");

    const sessionIdParam = urlParams.get("sessionId");
    const currentPageParam = urlParams.get("currentPage");
    const hwidParam = urlParams.get("hwid");
    const viewLessonParam = urlParams.get("ViewLesson");
    const previewModeParam = urlParams.get("PreviewMode");
    const lsnTestCodeParam = urlParams.get("LsnTestCode");
    const qnNoParam = urlParams.get("QnNo");

    /*
     * VIEW LESSON:
     * Stay on the TutorialsCopy route so QuestionCopy (which knows how to
     * return to CalledFrom on Done) is used instead of the student Question page.
     */
    if (viewLessonParam === "Y") {
      const vp = new URLSearchParams();
      vp.set("folder", idParam || "");
      vp.set("name", nameParam || lessonName);
      if (dicCodeParam) vp.set("diccode", dicCodeParam);
      if (lsnTestCodeParam) vp.set("LsnTestCode", lsnTestCodeParam);
      if (calledFromParam) vp.set("CalledFrom", calledFromParam);
      vp.set("ViewLesson", viewLessonParam);
      if (previewModeParam) vp.set("PreviewMode", previewModeParam);
      if (qnNoParam) vp.set("QnNo", qnNoParam);

      window.location.href = `/STUDENT/TutorialsCopy/Question?${vp.toString()}`;
      return;
    }

    /*
     * STUDENT FLOW: unchanged.
     */
    let redirectUrl =
      `/STUDENT/Tutorials/Question?folder=${encodeURIComponent(idParam || "")}` +
      `&name=${encodeURIComponent(nameParam || lessonName)}`;

    if (folderParam) {
      redirectUrl += `&diccode=${encodeURIComponent(folderParam)}`;
    }
    if (calledFromParam) {
      redirectUrl += `&calledFrom=${encodeURIComponent(calledFromParam)}`;
    }
    if (sessionIdParam) {
      redirectUrl += `&sessionId=${encodeURIComponent(sessionIdParam)}`;
    }
    if (currentPageParam) {
      redirectUrl += `&currentPage=${encodeURIComponent(currentPageParam)}`;
    }
    if (hwidParam) {
      redirectUrl += `&hwid=${encodeURIComponent(hwidParam)}`;
    }
    if (viewLessonParam) {
      redirectUrl += `&ViewLesson=${encodeURIComponent(viewLessonParam)}`;
    }
    if (previewModeParam) {
      redirectUrl += `&PreviewMode=${encodeURIComponent(previewModeParam)}`;
    }

    window.location.href = redirectUrl;
  };
  useEffect(() => {
    return () => {
      if (iframeSrc && iframeSrc.startsWith('blob:')) {
        URL.revokeObjectURL(iframeSrc);
      }
    };
  }, [iframeSrc]);

  return (
    <>
      {loading && <Loading />}

      <div className="tutorial-root" style={{ height: "100vh", display: "flex", flexDirection: "column" }}>

        <form id="form1" onSubmit={(e) => e.preventDefault()}
          style={{ display: "flex", flexDirection: "column", flex: "1 1 0", minHeight: 0 }}>

          <div style={{ flex: "0 0 auto" }}>
            <table cellPadding={0} cellSpacing={0} border={0} className='TutHeaderT'>
              <tbody>
                <tr className="TutHeader">
                  <td id="tdTitle" className="HeadMsg" style={{ color: "cornflowerblue", fontSize: "small", fontWeight: "bold" }}>
                    Lesson : <span id="spanTitle" style={{ color: "maroon", fontWeight: "bold" }}>{lessonName}</span>.&nbsp;&nbsp;Page &nbsp;
                    <span id="spanCurrentPageNo" style={{ color: "maroon" }}>{currentPage}</span> of &nbsp;
                    <span id="spanNoOfTutorialPages" style={{ color: "maroon" }}>{totalPages}</span>
                    <WhiteboardLink
                      schoolCode={params.get("SchoolCode") || params.get("schoolCode") || schoolCode}
                      familyCode={whiteboardFamilyCode}
                      login={whiteboardLogin}
                    />
                  </td>
                </tr>

                <tr className="TutNav">
                  <td id="tdTutNav" align="right" valign="middle" className='TutNavT'>
                    <table id="tblTutNav" className="TutNav" cellPadding={5} cellSpacing={0}>
                      <tbody>
                        <tr>
                          <td align="left" className='TutNav2T'>
                            <div
                              onClick={handleBack}
                              onMouseOver={() => setBackSrc(back_o)}
                              onMouseOut={() => setBackSrc(back_n)}
                              onMouseDown={() => setBackSrc(back_d)}
                              style={{ display: 'inline-block', cursor: 'pointer' }}
                            >
                              <img src={backSrc} alt="go back" />
                            </div>
                          </td>

                          <td align="left" className='TutNav3T' style={{ verticalAlign: "middle" }}>
                            {currentPage > 1 && (
                              <div
                                onClick={goToPreviousPage}
                                onMouseOver={() => setPreviousSrc(previous_o)}
                                onMouseOut={() => setPreviousSrc(previous_n)}
                                onMouseDown={() => setPreviousSrc(previous_d)}
                                style={{ display: 'inline-block', cursor: 'pointer' }}
                              >
                                <img src={previousSrc} alt="Previous Page" />
                              </div>
                            )}
                          </td>

                          <td align="right" className='TutNav3T'>
                            {hasMoreSteps ? (
                              <div
                                onClick={handleNextStep}
                                onMouseOver={() => setNextStepSrc(nextstep_o)}
                                onMouseOut={() => setNextStepSrc(nextstep_n)}
                                onMouseDown={() => setNextStepSrc(nextstep_d)}
                                style={{ display: 'inline-block', cursor: 'pointer' }}
                              >
                                <img src={nextStepSrc} alt="Next Step" />
                              </div>
                            ) : currentPage < totalPages ? (
                              <div
                                onClick={goToNextPage}
                                onMouseOver={() => setNextpageSrc(nextpage_o)}
                                onMouseOut={() => setNextpageSrc(nextpage_n)}
                                onMouseDown={() => setNextpageSrc(nextpage_d)}
                                style={{ display: 'inline-block', cursor: 'pointer' }}
                              >
                                <img src={nextpageSrc} alt="Next Page" />
                              </div>
                            ) : (
                              <div onClick={handleQuestion} style={{ display: 'inline-block', cursor: 'pointer' }}>
                                <img id='imgbtnQuestions' src={questionsSrc} alt="Questions"
                                  onMouseOver={() => setQuestionsSrc(questions_o)}
                                  onMouseOut={() => setQuestionsSrc(questions_n)}
                                  onMouseDown={() => setQuestionsSrc(questions_d)} />
                              </div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div style={{ flex: "1 1 0", minHeight: 0, overflow: "hidden" }}>
            <div id="divFrameTut" className='TutFrame2T'
              style={{ height: "100%", minHeight: 0, display: "flex", flexDirection: "column" }}
            >
              <iframe
                ref={iframeRef}
                id="iframeTut"
                title="Tutorial Content"
                className="iframeTutT"
                src={iframeSrc}
                frameBorder={0}
                scrolling="yes"
                style={{
                  display: "block",
                  width: "100%",
                  flex: "1 1 0",
                  height: "100%",
                  minHeight: 0,
                  border: "0px",
                  overflow: "auto",
                  backgroundColor: "white",
                  margin: "0px",
                  padding: "0px"
                }}
              ></iframe>
            </div>
          </div>

        </form>
      </div>
    </>
  );
};

export default TutorialCopy;